import React from 'react';
import './style.scss'
export const Loader = () => <div class="loader-ring"><div></div><div></div><div></div><div></div></div>

export default Loader;
